export const CART_DETAIL_PAGE_NAME = 'cart';
